import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Shell from "@/components/Shell";
import LoginPage from "@/pages/LoginPage";
import NewRequestPage from "@/pages/NewRequestPage";
import RequestsListPage from "@/pages/RequestsListPage";
import RequestDetailPage from "@/pages/RequestDetailPage";
import EditRequestPage from "@/pages/EditRequestPage";
import ReportsPage from "@/pages/ReportsPage";
import PurchasingInboxPage from "@/pages/PurchasingInboxPage";
import WarehouseInboxPage from "@/pages/WarehouseInboxPage";
import ReceiptCheckPage from "@/pages/ReceiptCheckPage";
import ProductsPage from "@/pages/ProductsPage";
import SuppliersPage from "@/pages/SuppliersPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children, adminOnly = false, roles = null }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Yükleniyor...</div>;
  if (!user || !user.id) return <Navigate to="/giris" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/talepler" replace />;
  if (roles) {
    // Honour admin-granted extra roles (e.g. "+Satın Alma") so purchasing pages
    // match the nav visibility in Shell (is_purchaser semantics).
    const extra = user.extra_roles || [];
    const allowed = roles.includes(user.role) || roles.some((r) => extra.includes(r));
    if (!allowed) return <Navigate to="/talepler" replace />;
  }
  return <Shell>{children}</Shell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/talepler" replace />} />
          <Route path="/talepler" element={<Protected><RequestsListPage /></Protected>} />
          <Route path="/talepler/:id" element={<Protected><RequestDetailPage /></Protected>} />
          <Route path="/talepler/:id/duzenle" element={<Protected><EditRequestPage /></Protected>} />
          <Route path="/talepler/:id/kontrol" element={<Protected><ReceiptCheckPage /></Protected>} />
          <Route path="/satinalma-kutusu" element={<Protected><PurchasingInboxPage /></Protected>} />
          <Route path="/depo-kutusu" element={<Protected><WarehouseInboxPage /></Protected>} />
          <Route path="/yeni-talep" element={<Protected><NewRequestPage /></Protected>} />
          <Route path="/raporlar" element={<Protected adminOnly><ReportsPage /></Protected>} />
          <Route path="/urunler" element={<Protected roles={["admin", "purchasing"]}><ProductsPage /></Protected>} />
          <Route path="/tedarikciler" element={<Protected roles={["admin", "purchasing"]}><SuppliersPage /></Protected>} />
          <Route path="/kullanicilar" element={<Protected adminOnly><UsersPage /></Protected>} />
          <Route path="/ayarlar" element={<Protected adminOnly><SettingsPage /></Protected>} />
          <Route path="*" element={<Navigate to="/talepler" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
